// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__238hM","Count":"Footer_Count__1tFYp","ButtonGroup":"Footer_ButtonGroup__2YZw2","ButtonDelete":"Footer_ButtonDelete__BvLEQ"};